import { gql } from 'graphql-request'

export const GenerateDocumentLinkGql = gql`
  mutation getResource($relativeUrl: String!) {
    documentLink(relativeUrl: $relativeUrl) {
      documentLink
      exceptionMessage
      fileWasNotFoundError
    }
  }
`
